import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function MentorshipDetailsTab(props) {
    const { session } = useContext(SessionContext);
    const mpackages = Array.isArray(props.mpackages) ? props.mpackages : [];
    const [loading, setLoading] = useState(true);

    // Original gradient pairs
    const gradients = [
        ['#009FE3', '#E6007E'],
        ['#FBF299', '#E6007E'],
        ['#E6007E', '#E24259'],
        ['#E6007E', '#FBF299'],
        ['#6EBC86', '#009FE3'],
        ['#6EBC86', '#FBF299'],
    ];
    // Slightly richer but still subtle versions
    const paleGradients = [
        ['#70CFF4', '#F472AD'],  // richer than #B2E2F6 / #F7B2D8
        ['#FAE672', '#F472AD'],  // richer than #FDFBE0 / #F7B2D8
        ['#E64C9A', '#E77A76'],  // richer than #F7B2D8 / #F6C6CD
        ['#E64C9A', '#FAE672'],  // richer than #F7B2D8 / #FDFBE0
        ['#A0D1B0', '#70CFF4'],  // richer than #D3EADA / #B2E2F6
        ['#A0D1B0', '#FAE672'],  // richer than #D3EADA / #FDFBE0
    ];

    const mpackageCards = mpackages.map((mpackage, idx) => {
        const [startColor, endColor] = paleGradients[idx % paleGradients.length];
        return (
            <div
                className="bundle-card"
                key={mpackage.price_id}
                style={{
                    background: `linear-gradient(135deg, ${startColor}, ${endColor})`,
                    color: '#333',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    padding: '1.5rem',
                    flex: '1 1 calc(33% - 1rem)',
                    boxSizing: 'border-box',
                }}
            >
                <div className="bundle-card-content">
                    <h4><strong>{mpackage.use_limit} sessions</strong></h4>
                    <p>€{mpackage.price} ({mpackage.discount_percent}% discount)</p>
                    <form action="https://www.campfr.com/api/mentorship_checkout" method="POST">
                        <input type="hidden" name="priceCode" value={mpackage.price_id} />
                        <input type="hidden" name="ws" value={session.ws} />
                        <button
                            className="confirm-process-button"
                            type="submit"
                            style={{
                                backgroundColor: '#fff',
                                color: '#333',
                                border: 'none',
                                padding: '0.6rem 1.2rem',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Buy now
                        </button>
                    </form>
                </div>
            </div>
        );
    });

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <h3 className="d-subtitle has-bg-image">Get 1:1 tuition and guidance from your workshop leader</h3>
            <div className="workshop_bodytext has-bg-image">
                <p>Following your CAMP workshop, you'll have the option to sign up for one or more individual mentorship sessions with your workshop leader. CAMP's mentorship program represents an incredible opportunity to take the results of your workshop and refine them, applying them to your specific practice under the guidance of an acclaimed artist.</p>

                <p>The mentorship program works like this: you sign up for a package of sessions - either 1, 6 or 12 meetings - with the workshop leader. Once you've signed up, you can book your preferred time slots in their calendar.</p>
                
                <p>Mentorship credits are transferrable between workshops, so if you sign up for multiple CAMP workshops, and you'd like to continue mentorship with all of the workshop leaders, you can buy a package of sessions and split them between different tutors - for example, you could buy a package of 12 sessions, and split them between three different workshops, so that you get 4 sessions with each workshop leader.</p>

                <p>Mentorship is only available to workshop alumni - it is not available as a standalone thing. If you want to start a mentorship program with a CAMP tutor, please sign up for their workshop first.</p>

                <div className="bundle-prices">
                    <div
                        className="bundles-cards"
                        style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}
                    >
                        {mpackageCards}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MentorshipDetailsTab;
